import { getCurrentUser } from '@features/auth';
import type { LogAndToastParams, LogLevel, ILogger } from '@types';
import { logger } from './loggerInstance';

type LoggerFn = NonNullable<ILogger['info']>;

function getLoggerFn (level: LogLevel, l: ILogger): LoggerFn {
  switch (level) {
  case 'info':    return l.info;
  case 'warning': return l.warning;
  case 'error':   return l.error;
  case 'success': return l.success ?? l.info;
  }
}

/** @deprecated In deprecation process: > 10.6.0 use write into logs instead
 * [Link]('./writeIntoLogs.ts')
 * **/
export const logAndToast = async ({
  message,
  level = 'error',
  toast = false,
  context = {},
  toastOptions,
  source,
  showToast,
  forceLog,
  ...options
}: LogAndToastParams): Promise<void> => {
  const user = getCurrentUser();

  const meta = {
    ...options,
    source,
    showToast: showToast ?? toast,
    forceLog,
    toastOptions: { className: level, ...toastOptions },
    context: {
      actor: { ...(user != null
        ? {
          userId: user.userId,
          email: user.email,
          userType: Array.isArray(user.type) ? user.type.join(', ') : undefined,
        }
        : {}) },
      ...context,
    },
  };

  const fn = getLoggerFn(level, logger);
  await fn(message, meta);
};
